module.exports = __webpack_public_path__ + "media/images/flags/1x1/sen-5e751a8ff35f602539ca4142b952cdb6.svg";